/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Reminders_Comment_PlaceholderInputs */

const en_task_reminders_comment_placeholder = /** @type {(inputs: Task_Reminders_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add an optional comment…`)
};

const pt_br2_task_reminders_comment_placeholder = /** @type {(inputs: Task_Reminders_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione um comentário opcional…`)
};

/**
* | output |
* | --- |
* | "Add an optional comment…" |
*
* @param {Task_Reminders_Comment_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_comment_placeholder = /** @type {((inputs?: Task_Reminders_Comment_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_Comment_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_comment_placeholder(inputs)
	return pt_br2_task_reminders_comment_placeholder(inputs)
});